var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"rb-step-indicator"},[_c('div',{staticClass:"rb-step-bar",style:(_vm.width)})])
}
var staticRenderFns = []

export { render, staticRenderFns }